/* ============================================================
   ZAVANI - Theme JavaScript
   Premium Madagascar Vanilla
   Version: 1.0.0
   ============================================================ */

document.addEventListener('DOMContentLoaded', function () {
  'use strict';

  /* ==========================================================================
     HELPERS
     ========================================================================== */

  /**
   * Format price in EUR format: XX,XX €
   * Shopify returns prices in cents
   */
  function formatMoney(cents) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = (parseInt(cents, 10) / 100).toFixed(2);
    return value.replace('.', ',') + ' \u20AC';
  }

  /**
   * Fetch wrapper with JSON parsing
   */
  function fetchJSON(url, options) {
    return fetch(url, options).then(function (response) {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    });
  }

  /**
   * Debounce function
   */
  function debounce(fn, delay) {
    var timer = null;
    return function () {
      var context = this;
      var args = arguments;
      clearTimeout(timer);
      timer = setTimeout(function () {
        fn.apply(context, args);
      }, delay);
    };
  }

  /**
   * Trap focus within an element (for modals/drawers)
   */
  function trapFocus(element) {
    var focusableElements = element.querySelectorAll(
      'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])'
    );
    if (focusableElements.length === 0) return;

    var firstFocusable = focusableElements[0];
    var lastFocusable = focusableElements[focusableElements.length - 1];

    element.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;

      if (e.shiftKey) {
        if (document.activeElement === firstFocusable) {
          lastFocusable.focus();
          e.preventDefault();
        }
      } else {
        if (document.activeElement === lastFocusable) {
          firstFocusable.focus();
          e.preventDefault();
        }
      }
    });

    firstFocusable.focus();
  }

  /* ==========================================================================
     MOBILE MENU
     ========================================================================== */

  var MobileMenu = (function () {
    var menuToggle = document.querySelector('[data-mobile-menu-open]');
    var menuClose = document.querySelector('[data-mobile-menu-close]');
    var mobileNav = document.getElementById('mobile-menu');
    var mobileNavOverlay = document.querySelector('[data-mobile-menu-overlay]');

    if (!menuToggle || !mobileNav) return;

    function open() {
      mobileNav.classList.add('is-open');
      if (mobileNavOverlay) mobileNavOverlay.classList.add('is-open');
      document.body.classList.add('menu-open');
      mobileNav.setAttribute('aria-hidden', 'false');
      trapFocus(mobileNav);
    }

    function close() {
      mobileNav.classList.remove('is-open');
      if (mobileNavOverlay) mobileNavOverlay.classList.remove('is-open');
      document.body.classList.remove('menu-open');
      mobileNav.setAttribute('aria-hidden', 'true');
      menuToggle.focus();
    }

    menuToggle.addEventListener('click', function () {
      if (mobileNav.classList.contains('is-open')) {
        close();
      } else {
        open();
      }
    });

    if (menuClose) {
      menuClose.addEventListener('click', close);
    }

    if (mobileNavOverlay) {
      mobileNavOverlay.addEventListener('click', close);
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && mobileNav.classList.contains('is-open')) {
        close();
      }
    });

    return { open: open, close: close };
  })();

  /* ==========================================================================
     CART DRAWER
     ========================================================================== */

  var CartDrawer = (function () {
    var overlay = document.getElementById('cart-drawer-overlay');
    var drawer = document.getElementById('cart-drawer');
    var closeBtn = document.getElementById('cart-drawer-close');
    var body = document.getElementById('cart-drawer-body');
    var footer = document.getElementById('cart-drawer-footer');
    var cartCountElements = document.querySelectorAll('[data-cart-count]');

    if (!drawer) return;

    function open() {
      drawer.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
      document.body.classList.add('cart-open');
      drawer.setAttribute('aria-hidden', 'false');
      refreshCart();
      trapFocus(drawer);
    }

    function close() {
      drawer.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      document.body.classList.remove('cart-open');
      drawer.setAttribute('aria-hidden', 'true');
    }

    function refreshCart() {
      fetchJSON('/cart.js')
        .then(function (cart) {
          renderCart(cart);
          updateCartCount(cart.item_count);
        })
        .catch(function (error) {
          console.error('Error fetching cart:', error);
        });
    }

    function updateCartCount(count) {
      cartCountElements.forEach(function (el) {
        el.textContent = count;
        el.setAttribute('data-count', count);
        if (count > 0) {
          el.style.display = '';
        } else {
          el.style.display = 'none';
        }
      });
    }

    function renderCart(cart) {
      if (!body || !footer) return;

      if (cart.item_count === 0) {
        body.innerHTML =
          '<div class="cart-drawer__empty">' +
            '<div class="cart-drawer__empty-icon">' +
              '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg>' +
            '</div>' +
            '<p class="cart-drawer__empty-title">Panier vide</p>' +
            '<p class="cart-drawer__empty-text">Il semble que vous n\u2019avez pas encore fait votre choix.</p>' +
            '<a href="/collections/all" class="btn btn-primary">Continuer vos achats</a>' +
          '</div>';
        footer.innerHTML = '';
        footer.style.display = 'none';
        return;
      }

      footer.style.display = '';

      var itemsHTML = '';
      cart.items.forEach(function (item) {
        var imageUrl = item.image
          ? item.image.replace(/(\.[^.]+)$/, '_200x$1')
          : '';
        var variantTitle =
          item.variant_title && item.variant_title !== 'Default Title'
            ? item.variant_title
            : '';

        itemsHTML +=
          '<div class="cart-item" data-key="' + item.key + '">' +
            '<div class="cart-item__image">' +
              (imageUrl
                ? '<img src="' + imageUrl + '" alt="' + item.title + '" loading="lazy">'
                : '<div class="image-placeholder" style="width:100%;height:100%"></div>') +
            '</div>' +
            '<div class="cart-item__details">' +
              '<div>' +
                '<p class="cart-item__title"><a href="' + item.url + '">' + item.product_title + '</a></p>' +
                (variantTitle
                  ? '<p class="cart-item__variant">' + variantTitle + '</p>'
                  : '') +
              '</div>' +
              '<div class="cart-item__bottom">' +
                '<div class="cart-item__quantity">' +
                  '<button class="cart-item__quantity-btn" data-action="decrease" data-key="' + item.key + '" aria-label="Diminuer la quantit\u00E9">' +
                    '<svg width="10" height="10" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2"><line x1="4" y1="10" x2="16" y2="10"/></svg>' +
                  '</button>' +
                  '<span class="cart-item__quantity-value">' + item.quantity + '</span>' +
                  '<button class="cart-item__quantity-btn" data-action="increase" data-key="' + item.key + '" aria-label="Augmenter la quantit\u00E9">' +
                    '<svg width="10" height="10" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2"><line x1="10" y1="4" x2="10" y2="16"/><line x1="4" y1="10" x2="16" y2="10"/></svg>' +
                  '</button>' +
                '</div>' +
                '<span class="cart-item__price">' + formatMoney(item.final_line_price) + '</span>' +
              '</div>' +
              '<button class="cart-item__remove" data-action="remove" data-key="' + item.key + '">Supprimer</button>' +
            '</div>' +
          '</div>';
      });

      body.innerHTML = itemsHTML;

      footer.innerHTML =
        '<div class="cart-drawer__subtotal">' +
          '<span class="cart-drawer__subtotal-label">Sous-total</span>' +
          '<span class="cart-drawer__subtotal-price">' + formatMoney(cart.total_price) + '</span>' +
        '</div>' +
        '<p class="cart-drawer__shipping-note">Frais de livraison calcul\u00E9s \u00E0 l\u2019\u00E9tape suivante</p>' +
        '<a href="/checkout" class="btn btn-primary btn--full cart-drawer__checkout">Passer la commande</a>' +
        '<a href="/collections/all" class="cart-drawer__continue">Continuer vos achats</a>';

      // Bind quantity and remove buttons
      body.querySelectorAll('[data-action]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var key = this.getAttribute('data-key');
          var action = this.getAttribute('data-action');

          if (action === 'remove') {
            updateItem(key, 0);
          } else if (action === 'decrease') {
            var currentQty = parseInt(
              this.closest('.cart-item').querySelector('.cart-item__quantity-value').textContent,
              10
            );
            if (currentQty > 1) {
              updateItem(key, currentQty - 1);
            } else {
              updateItem(key, 0);
            }
          } else if (action === 'increase') {
            var currentQty2 = parseInt(
              this.closest('.cart-item').querySelector('.cart-item__quantity-value').textContent,
              10
            );
            updateItem(key, currentQty2 + 1);
          }
        });
      });
    }

    function addToCart(formData) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify(formData),
      })
        .then(function (response) {
          if (!response.ok) {
            return response.json().then(function (data) {
              throw new Error(data.description || 'Erreur lors de l\u2019ajout au panier');
            });
          }
          return response.json();
        })
        .then(function (item) {
          open();
          return item;
        })
        .catch(function (error) {
          console.error('Add to cart error:', error);
          showNotification(error.message, 'error');
          throw error;
        });
    }

    function updateItem(key, quantity) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ id: key, quantity: quantity }),
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (cart) {
          renderCart(cart);
          updateCartCount(cart.item_count);
        })
        .catch(function (error) {
          console.error('Update cart error:', error);
        });
    }

    // Event listeners
    if (closeBtn) {
      closeBtn.addEventListener('click', close);
    }

    if (overlay) {
      overlay.addEventListener('click', close);
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
        close();
      }
    });

    // Cart icon click - open drawer
    document.querySelectorAll('[data-cart-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        open();
      });
    });

    // Initialize cart count on page load
    fetchJSON('/cart.js')
      .then(function (cart) {
        updateCartCount(cart.item_count);
      })
      .catch(function () {});

    return {
      open: open,
      close: close,
      addToCart: addToCart,
      refreshCart: refreshCart,
      updateCartCount: updateCartCount,
    };
  })();

  // Expose CartDrawer globally for product forms
  window.CartDrawer = CartDrawer;

  /* ==========================================================================
     SCROLL ANIMATIONS (IntersectionObserver)
     ========================================================================== */

  (function () {
    var animatedElements = document.querySelectorAll('.animate-on-scroll');

    if (animatedElements.length === 0) return;

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        {
          threshold: 0.1,
          rootMargin: '0px 0px -40px 0px',
        }
      );

      animatedElements.forEach(function (el) {
        observer.observe(el);
      });
    } else {
      // Fallback: show all elements
      animatedElements.forEach(function (el) {
        el.classList.add('is-visible');
      });
    }
  })();

  /* ==========================================================================
     STICKY HEADER
     ========================================================================== */

  (function () {
    var header = document.querySelector('.header');
    if (!header) return;

    var scrollThreshold = 100;

    function onScroll() {
      if (window.scrollY > scrollThreshold) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  })();

  /* ==========================================================================
     PRODUCT PAGE INTERACTIONS
     ========================================================================== */

  (function () {
    var productForm = document.querySelector('[data-product-form]');
    if (!productForm) return;

    var productData = null;
    var productJsonEl = document.querySelector('[data-product-json]');
    if (productJsonEl) {
      try {
        productData = JSON.parse(productJsonEl.textContent);
      } catch (e) {
        console.error('Error parsing product JSON:', e);
        return;
      }
    }

    // Variant selector
    var optionSelectors = productForm.querySelectorAll('[data-option-selector]');
    var variantIdInput = productForm.querySelector('[name="id"]');
    var priceEl = document.querySelector('[data-product-price]');
    var comparePriceEl = document.querySelector('[data-product-compare-price]');
    var addToCartBtn = productForm.querySelector('[data-add-to-cart]');
    var addToCartText = productForm.querySelector('[data-add-to-cart-text]');
    var mainImage = document.querySelector('[data-product-main-image]');

    function getSelectedOptions() {
      var options = [];
      optionSelectors.forEach(function (selector) {
        if (selector.tagName === 'SELECT') {
          options.push(selector.value);
        } else {
          // Radio buttons
          var checked = selector.querySelector('input:checked');
          if (checked) {
            options.push(checked.value);
          }
        }
      });
      return options;
    }

    function findVariant(selectedOptions) {
      if (!productData || !productData.variants) return null;

      return productData.variants.find(function (variant) {
        return variant.options.every(function (option, index) {
          return option === selectedOptions[index];
        });
      });
    }

    function onVariantChange() {
      var selectedOptions = getSelectedOptions();
      var variant = findVariant(selectedOptions);

      if (!variant) {
        if (addToCartBtn) addToCartBtn.disabled = true;
        if (addToCartText) addToCartText.textContent = 'Indisponible';
        return;
      }

      // Update hidden variant ID
      if (variantIdInput) {
        variantIdInput.value = variant.id;
      }

      // Update price
      if (priceEl) {
        priceEl.textContent = formatMoney(variant.price);
      }

      if (comparePriceEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          comparePriceEl.textContent = formatMoney(variant.compare_at_price);
          comparePriceEl.style.display = '';
        } else {
          comparePriceEl.style.display = 'none';
        }
      }

      // Update availability
      if (addToCartBtn && addToCartText) {
        if (variant.available) {
          addToCartBtn.disabled = false;
          addToCartText.textContent = 'Ajouter au panier';
        } else {
          addToCartBtn.disabled = true;
          addToCartText.textContent = '\u00C9puis\u00E9';
        }
      }

      // Update main image if variant has a featured image
      if (mainImage && variant.featured_image) {
        mainImage.src = variant.featured_image.src;
        mainImage.alt = variant.featured_image.alt || variant.title;
      }

      // Update URL without reload
      if (variant.id) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    optionSelectors.forEach(function (selector) {
      selector.addEventListener('change', onVariantChange);
    });

    // Quantity selector
    var quantityWrapper = productForm.querySelector('.quantity-selector');
    if (quantityWrapper) {
      var quantityInput = quantityWrapper.querySelector('.quantity-selector__input');
      var decreaseBtn = quantityWrapper.querySelector('[data-quantity-decrease]');
      var increaseBtn = quantityWrapper.querySelector('[data-quantity-increase]');

      if (decreaseBtn && increaseBtn && quantityInput) {
        decreaseBtn.addEventListener('click', function () {
          var val = parseInt(quantityInput.value, 10);
          if (val > 1) {
            quantityInput.value = val - 1;
          }
        });

        increaseBtn.addEventListener('click', function () {
          var val = parseInt(quantityInput.value, 10);
          quantityInput.value = val + 1;
        });

        quantityInput.addEventListener('change', function () {
          var val = parseInt(this.value, 10);
          if (isNaN(val) || val < 1) {
            this.value = 1;
          }
        });
      }
    }

    // Product image gallery - thumbnail click
    var thumbnails = document.querySelectorAll('.product-page__thumbnail');
    var mainImageWrapper = document.querySelector('[data-product-main-image]');
    thumbnails.forEach(function (thumb) {
      thumb.addEventListener('click', function (e) {
        e.preventDefault();

        // Update main image
        var imgSrc = this.getAttribute('data-thumbnail-src');
        var imgSrcset = this.getAttribute('data-thumbnail-srcset');
        var imgAlt = this.getAttribute('data-thumbnail-alt') || '';
        var mainImg = mainImageWrapper ? mainImageWrapper.querySelector('img') : mainImage;
        if (mainImg) {
          mainImg.src = imgSrc;
          if (imgSrcset) mainImg.srcset = imgSrcset;
          mainImg.alt = imgAlt;
        }

        // Update active thumbnail
        thumbnails.forEach(function (t) {
          t.classList.remove('is-active');
        });
        this.classList.add('is-active');
      });
    });

    // Add to cart via AJAX
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();

      if (addToCartBtn) addToCartBtn.classList.add('is-loading');

      var formData = {
        id: parseInt(variantIdInput ? variantIdInput.value : productForm.querySelector('[name="id"]').value, 10),
        quantity: parseInt(productForm.querySelector('[name="quantity"]')
          ? productForm.querySelector('[name="quantity"]').value
          : 1, 10),
      };

      if (CartDrawer) {
        CartDrawer.addToCart(formData)
          .then(function () {
            if (addToCartBtn) addToCartBtn.classList.remove('is-loading');
            // Brief success indication
            if (addToCartText) {
              var originalText = addToCartText.textContent;
              addToCartText.textContent = 'Ajout\u00E9 !';
              setTimeout(function () {
                addToCartText.textContent = originalText;
              }, 2000);
            }
          })
          .catch(function () {
            if (addToCartBtn) addToCartBtn.classList.remove('is-loading');
          });
      }
    });
  })();

  /* ==========================================================================
     PRODUCT TABS
     ========================================================================== */

  (function () {
    var tabsContainer = document.querySelector('[data-product-tabs]');
    if (!tabsContainer) return;

    var tabBtns = tabsContainer.querySelectorAll('[data-tab-btn]');
    var tabPanels = tabsContainer.querySelectorAll('[data-tab-panel]');

    tabBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = this.getAttribute('data-tab-btn');

        // Update buttons
        tabBtns.forEach(function (b) {
          b.classList.remove('is-active');
          b.setAttribute('aria-selected', 'false');
        });
        this.classList.add('is-active');
        this.setAttribute('aria-selected', 'true');

        // Update panels
        tabPanels.forEach(function (panel) {
          panel.classList.remove('is-active');
        });
        var activePanel = tabsContainer.querySelector('[data-tab-panel="' + target + '"]');
        if (activePanel) {
          activePanel.classList.add('is-active');
        }
      });
    });
  })();

  /* ==========================================================================
     FAQ ACCORDION
     ========================================================================== */

  (function () {
    var accordionItems = document.querySelectorAll('.accordion__item');
    if (accordionItems.length === 0) return;

    accordionItems.forEach(function (item) {
      var trigger = item.querySelector('.accordion__trigger');
      var content = item.querySelector('.accordion__content');

      if (!trigger || !content) return;

      trigger.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');

        // Close all other items
        accordionItems.forEach(function (otherItem) {
          if (otherItem !== item && otherItem.classList.contains('is-open')) {
            otherItem.classList.remove('is-open');
            var otherContent = otherItem.querySelector('.accordion__content');
            if (otherContent) {
              otherContent.style.maxHeight = null;
            }
          }
        });

        // Toggle current item
        if (isOpen) {
          item.classList.remove('is-open');
          content.style.maxHeight = null;
        } else {
          item.classList.add('is-open');
          content.style.maxHeight = content.scrollHeight + 'px';
        }
      });
    });
  })();

  /* ==========================================================================
     NEWSLETTER FORM
     ========================================================================== */

  (function () {
    var newsletterForms = document.querySelectorAll('[data-newsletter-form]');

    newsletterForms.forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();

        var emailInput = form.querySelector('input[type="email"]');
        var successMsg = form.parentElement.querySelector('.newsletter__success');

        if (!emailInput || !emailInput.value) return;

        // Simulate form submission (Shopify handles the actual subscription)
        // In a real implementation, this would POST to the Shopify customer API
        // For now, just show success
        form.style.display = 'none';
        if (successMsg) {
          successMsg.classList.add('is-visible');
        }
      });
    });
  })();

  /* ==========================================================================
     PRODUCT RECOMMENDATIONS (AJAX)
     ========================================================================== */

  (function () {
    var recSection = document.querySelector('[data-product-recommendations]');
    if (!recSection) return;

    var url = recSection.getAttribute('data-url');
    if (!url) return;

    fetch(url)
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newContent = doc.querySelector('[data-product-recommendations]');
        if (newContent && newContent.innerHTML.trim() !== '') {
          recSection.innerHTML = newContent.innerHTML;
        }
      })
      .catch(function (error) {
        console.error('Error loading recommendations:', error);
      });
  })();

  /* ==========================================================================
     COLLECTION SORT
     ========================================================================== */

  (function () {
    var sortSelect = document.querySelector('[data-sort-select]');
    if (!sortSelect) return;

    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });
  })();

  /* ==========================================================================
     SMOOTH SCROLL FOR ANCHOR LINKS
     ========================================================================== */

  (function () {
    document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
      anchor.addEventListener('click', function (e) {
        var targetId = this.getAttribute('href');
        if (targetId === '#' || targetId === '') return;

        var target = document.querySelector(targetId);
        if (!target) return;

        e.preventDefault();

        var headerHeight = document.querySelector('.header')
          ? document.querySelector('.header').offsetHeight
          : 0;

        var targetPosition = target.getBoundingClientRect().top + window.pageYOffset - headerHeight - 20;

        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth',
        });
      });
    });
  })();

  /* ==========================================================================
     ANNOUNCEMENT BAR CLOSE
     ========================================================================== */

  (function () {
    var closeBtn = document.querySelector('.announcement-bar__close');
    if (!closeBtn) return;

    var announcementBar = closeBtn.closest('.announcement-bar');
    if (!announcementBar) return;

    // Check if previously dismissed in this session
    if (sessionStorage.getItem('zavani-announcement-dismissed') === 'true') {
      announcementBar.classList.add('is-hidden');
      return;
    }

    closeBtn.addEventListener('click', function () {
      announcementBar.classList.add('is-hidden');
      sessionStorage.setItem('zavani-announcement-dismissed', 'true');
    });
  })();

  /* ==========================================================================
     NOTIFICATIONS / TOAST
     ========================================================================== */

  function showNotification(message, type) {
    type = type || 'success';

    // Remove existing notification
    var existing = document.querySelector('.notification');
    if (existing) existing.remove();

    var notification = document.createElement('div');
    notification.className = 'notification notification--' + type;
    notification.innerHTML =
      '<span class="notification__message">' + message + '</span>' +
      '<button class="notification__close" aria-label="Fermer">' +
        '<svg width="14" height="14" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="4" y1="4" x2="16" y2="16"/><line x1="16" y1="4" x2="4" y2="16"/></svg>' +
      '</button>';

    document.body.appendChild(notification);

    // Trigger reflow for animation
    notification.offsetHeight;
    notification.classList.add('is-visible');

    // Close button
    notification.querySelector('.notification__close').addEventListener('click', function () {
      notification.classList.remove('is-visible');
      setTimeout(function () {
        notification.remove();
      }, 300);
    });

    // Auto-dismiss after 4 seconds
    setTimeout(function () {
      if (notification.parentNode) {
        notification.classList.remove('is-visible');
        setTimeout(function () {
          if (notification.parentNode) notification.remove();
        }, 300);
      }
    }, 4000);
  }

  window.showNotification = showNotification;

  /* ==========================================================================
     ADD TO CART BUTTONS (collection pages, quick add)
     ========================================================================== */

  (function () {
    document.querySelectorAll('[data-quick-add]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var variantId = this.getAttribute('data-variant-id');
        if (!variantId) return;

        this.classList.add('is-loading');
        var self = this;

        if (CartDrawer) {
          CartDrawer.addToCart({ id: parseInt(variantId, 10), quantity: 1 })
            .then(function () {
              self.classList.remove('is-loading');
            })
            .catch(function () {
              self.classList.remove('is-loading');
            });
        }
      });
    });
  })();

  /* ==========================================================================
     LAZY LOAD IMAGES (native fallback)
     ========================================================================== */

  (function () {
    if ('loading' in HTMLImageElement.prototype) {
      // Browser supports native lazy loading
      document.querySelectorAll('img[data-src]').forEach(function (img) {
        img.src = img.dataset.src;
        if (img.dataset.srcset) {
          img.srcset = img.dataset.srcset;
        }
      });
    } else if ('IntersectionObserver' in window) {
      // Fallback for older browsers
      var lazyObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var img = entry.target;
            img.src = img.dataset.src;
            if (img.dataset.srcset) {
              img.srcset = img.dataset.srcset;
            }
            img.removeAttribute('data-src');
            lazyObserver.unobserve(img);
          }
        });
      });

      document.querySelectorAll('img[data-src]').forEach(function (img) {
        lazyObserver.observe(img);
      });
    }
  })();
});
